<template>
  <div class="searchShop">
    リダイレクトします
  </div>
</template>

<script>
export default {
  name: "searchShop",
  components: {},
  methods: {},
  mounted() {
    window.open('https://location.am-all.net/alm/location?gm=99', '_blank')
  }
}
</script>

<style scoped>
.searchShop {
  font-size: 12px;
  color: #373737;
  padding: 40px;
}
</style>
